import type { Locale } from 'date-fns';
import enUsLocale from 'date-fns/locale/en-US';

import { formatLong } from './formatLong';
import { formatRelative } from './formatRelative';
import { localize } from './localize';

/**
 * @type {Locale}
 * @category Locales
 * @summary Urdu locale.
 * @language Urdu
 */
export const urLocale: Locale = {
  code: 'ur',
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
};
